import { render, staticRenderFns } from "./BeforeYouStart.vue?vue&type=template&id=679991f4&"
import script from "./BeforeYouStart.vue?vue&type=script&lang=js&"
export * from "./BeforeYouStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports